// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DriverLeadRepoConfig from "./DriverLeadRepoConfig.bs.js";

var driverLeadBasicInfoDummyResponse = [
    {
        "internalId": 4402,
        "externalId": "00000000-0000-0000-0000-00000000000",
        "basicInfo": {
            "mobile": "0000000000",
            "name": "New Laxmikant Owner Fhajnfjfk",
            "dateOfJoin": 1699453709209,
            "isOwnerDriver": true,
            "city": {
                "internalId": 3,
                "name": "Bangalore"
            }
        },
        "ownerInfo": {
            "internalId": 3765,
            "mobile": "0000000000",
            "name": "New Laxmikant Owner Fhajnfjfk"
        },
        "vehicleInfo": {
            "internalId": 3951,
            "externalId": "00000000-0000-0000-0000-00000000000",
            "number": "KA-00-00-0000",
            "category": {
                "internalId": 83,
                "vehicleType": "2 Wheeler",
                "displayName": "2 Wheeler"
            },
            "bodyType": null
        },
        "statusInfo": {
            "status": 2,
            "onboardingStatus": 1,
            "lastUpdatedAt": 1699595115952,
            "waitlistInfo": {
                "isWaitlisted": false,
                "waitlistReason": 1,
                "waitlistedAt": 1699453711000,
                "waitlistEndedAt": 1699473672000
            }
        }
    }
];

var driverPaymentHistoryDummyResponse = {
	"payment_history": [{
		"amount": 600.00,
		"status": "INITIATED",
		"lead_id": "uuid",
		"transactionId": "Hello Test",
		"created_at": 1693459013,
		"updated_at": 1693459013
	}]
};

function fetchDriverLeadBasicInfo(driver_number, country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: driverLeadBasicInfoDummyResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverLeadRepoConfig.DriverLeadResponseConverter.execute, result);
                        });
            });
}

function fetchDriverPaymentHistory(lead_id, country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: driverPaymentHistoryDummyResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverLeadRepoConfig.DriverPaymentHistoryResponseConverter.execute, result);
                        });
            });
}

var DriverLeadRepo = {
  fetchDriverLeadBasicInfo: fetchDriverLeadBasicInfo,
  fetchDriverPaymentHistory: fetchDriverPaymentHistory
};

export {
  DriverLeadRepo ,
  
}
/* DriverLeadRepoConfig Not a pure module */
